import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles(({ spacing, palette }) => ({
  // 480 wide, 24 / 24 / 16 — the same shell as the import-side warning.
  paper: {
    width: 480,
    maxWidth: "100%",
    padding: spacing(3, 3, 2),
  },
  header: {
    color: palette.common.black,
    fontSize: 24,
    fontWeight: 500,
    lineHeight: "normal",
    marginBottom: spacing(2),
  },
  // `&&`: both the shared `Alert` and `MuiAlert-root` set colour and typography.
  banner: {
    marginBottom: spacing(2),
    "&&": {
      color: grey[800],
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 1.5,
    },
  },
  // A triangle, not the shared `Alert`'s info circle.
  bannerIcon: {
    color: palette.warning.main,
  },
  // 8 all round and 8 to the wording. The margin reset undoes MUI's -11 pull.
  option: {
    padding: spacing(1),
    "& .MuiFormControlLabel-root": {
      margin: 0,
      gap: spacing(1),
    },
  },
  optionLabel: {
    color: palette.common.black,
    fontSize: 14,
    fontWeight: 500,
    lineHeight: 1.5,
  },
  // Indented to the radio's label; one gap spaces everything inside.
  optionBody: {
    display: "flex",
    flexDirection: "column",
    gap: spacing(2),
    paddingLeft: spacing(4),
  },
  optionHint: {
    color: palette.common.black,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.5,
  },
  field: {
    width: "100%",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: spacing(1),
    marginTop: spacing(2),
  },
}));
